import { useCallback, useEffect, useRef, useState } from "react";
import MergerAcquisitionHome from "./MergerAcquisitionScan";
import { ContextMenu } from "client/CommonComponents";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import userProfileSelectors from '../../../../redux/UserProfile/selectors'
import { getAllScans, isScanSaved, saveScan, updateScan, setFilters, setPaginationData, getScansExcelExportFile, setScansExcelExportFile, uploadAssets, isAssetsUploaded as setIsAssetsUploaded } from "Store/AssetInventory/MandAScan/MandAScanAction";
import permissions, { isAuthorized } from "client/utils/Permissions";
import { ASSET_INVENTORY } from "client/utils/constants/accessDeniedAssetInventory";
import { base64ToArrayBuffer, saveByteArray } from "../../../../utils";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import { useNavigate } from "react-router-dom";

const MergerAcquisitionHomeContainer = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [gridData, setGridData] = useState<any>([])
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [pagesCount, setPagesCount] = useState<number>(0)
  const [showCreateNewScanPopup, setShowCreateNewPopup] = useState(false)
  const [showEditScanPopup, setShowEditPopup] = useState(false)
  const [showUploadAssetsPopUp, setShowUploadAssetsPopUp] = useState(false)
  const [values, setValues] = useState<any>({})
  const [globalSearchBox, setGlobalSearchBox] = useState<string>('')
  const [list, setList] = useState<any>([])

  const dealDate = useRef<any>();
  const scanStartDate = useRef<any>();
  const scanEndDate = useRef<any>();
  const createdDate = useRef<any>();

  const { 
    userData, 
    isScanSavedFlag, 
    allScans, 
    filters, 
    paginationData, 
    scansExcelExportFile,
    isAssetsUploaded 
    }: any = useSelector((state: any) => ({
    userData: userProfileSelectors.getUserDetails(state),
    isScanSavedFlag: state.mergerAndAquisitionReducer.isScanSavedFlag,
    allScans: state.mergerAndAquisitionReducer.allScans,
    filters: state.mergerAndAquisitionReducer.filters,
    paginationData: state.mergerAndAquisitionReducer.paginationData,
    scansExcelExportFile: state.mergerAndAquisitionReducer.scansExcelExportFile,
    isAssetsUploaded: state.mergerAndAquisitionReducer.isAssetsUploaded,
  }))

  useEffect(() => {
    if(userData?.permissions?.length && !isAuthorized(permissions?.ViewMAScanning)){
      navigate('/assetinventory')
    }
  }, [userData?.permissions])

  useEffect(() => {
    if (userData?.emailId) {
      let filterObj: any = {
        pageNumber: (paginationData?.pageIndex ?? 0) + 1,
        pageSize: (paginationData?.pageSize ?? 10),
        loggedInMail: userData?.emailId,
        columnFilters: Object
          .keys(filters)
          ?.map((filter: any) => ({
            'field': filter,
            'value': filters[filter]
          })),
        onlyActive: true,
      }
      dispatch(getAllScans(filterObj))
    }
  }, [filters, paginationData, userData?.emailId])

  const globalDebounce = useDebounce(globalSearchBox, 700)

  useEffect(() => {
      let filterObj: any = {
        pageNumber: 1,
        pageSize: (paginationData?.pageSize ?? 10),
        loggedInMail: userData?.emailId,
        globalSearch: globalDebounce,
        columnFilters: Object
          .keys(filters)
          ?.map((filter: any) => ({
            'field': filter,
            'value': filters[filter]
          })),
        onlyActive: true,
      }
      dispatch(getAllScans(filterObj))
  }, [globalDebounce])

  useEffect(() => {
    if (filters) {
      dealDate.current = filters?.dealDate ? new Date(filters?.dealDate) : null
      scanStartDate.current = filters?.scanStartDate ? new Date(filters?.scanStartDate) : null
      scanEndDate.current = filters?.scanEndDate ? new Date(filters?.scanEndDate) : null
      createdDate.current = filters?.createdDate ? new Date(filters?.createdDate) : null

    }
  }, [])

  useEffect(() => {
    let dataTemp = allScans?.data?.map((scan: any) => {
      return {
        ...scan,
        dealDate: moment(scan?.dealDate).format('MM/DD/YYYY'),
        scanEndDate: moment(scan?.scanEndDate).format('MM/DD/YYYY'),
        scanStartDate: moment(scan?.scanStartDate).format('MM/DD/YYYY'),
        createdDate: moment(scan?.createdDate).format('MM/DD/YYYY'),
      }
    })
    let pageSize = paginationData?.pageSize ?? 10
    let tempPageCount = allScans?.totalRecords > pageSize ? Math.ceil(allScans?.totalRecords / pageSize - 1) : 0
    setPagesCount(tempPageCount)
    setTotalRecords(allScans?.totalRecords)
    setGridData(dataTemp)
  }, [allScans])

  useEffect(() => {
    if (isScanSavedFlag?.status && showCreateNewScanPopup) {
      setTimeout(() => {
        let filterObj: any = {
          pageNumber: (paginationData?.pageIndex ?? 0) + 1,
          pageSize: (paginationData?.pageSize ?? 10),
          loggedInMail: userData?.emailId,
          columnFilters: Object
            .keys(filters)
            ?.map((filter: any) => ({
              'field': filter,
              'value': filters[filter]
            })),
          onlyActive: true,
        }
        hidePopup()
        dispatch(getAllScans(filterObj))
      }, 1200)
    }
  }, [isScanSavedFlag?.status])

  useEffect(() => {
    if (isAssetsUploaded?.status && showUploadAssetsPopUp) {
      setTimeout(() => {
        let filterObj: any = {
          pageNumber: (paginationData?.pageIndex ?? 0) + 1,
          pageSize: (paginationData?.pageSize ?? 10),
          loggedInMail: userData?.emailId,
          columnFilters: Object
            .keys(filters)
            ?.map((filter: any) => ({
              'field': filter,
              'value': filters[filter]
            })),
          onlyActive: true,
        }
        hidePopup()
        dispatch(setIsAssetsUploaded({ status: '', message: '' }))
        setShowUploadAssetsPopUp(false)
        setList([])
        dispatch(getAllScans(filterObj))
      }, 1200)
    } else if(isAssetsUploaded?.status === false && showUploadAssetsPopUp){
      setTimeout(() => {
        dispatch(setIsAssetsUploaded({ status: '', message: '' }))
      }, 5000)
    }
  }, [isAssetsUploaded?.status])


  useEffect(() => {
    if (scansExcelExportFile) {
      const byteArray = base64ToArrayBuffer(scansExcelExportFile)
      saveByteArray('m&a_scans', byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
      dispatch(setScansExcelExportFile(''))
    }
  }, [scansExcelExportFile])

  const CreateNewScanClick = () => {
    setShowCreateNewPopup(true)
    setShowEditPopup(false)
  }

  const hidePopup = () => {
    setValues({})
    dispatch(isScanSaved({ status: '', message: '' }))
    setShowCreateNewPopup(false)
  }

  useEffect(() => {
    document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
  }, []);

  const CustomCell = (rowData: any) => {
    const [showContextualMenu, setShowContextualMenu] = useState(false);
    const onShowContextualMenu = (ev: React.MouseEvent<HTMLElement>) => {
      ev.preventDefault(); // don't navigate
      setShowContextualMenu(true);
    }

    const menuItems = isAuthorized(permissions?.CreateEditMAScan) || isAuthorized(permissions?.ViewMAScanning) ? [
      {
        key: 'Edit',
        text: 'Edit',
        onClick: () => {
          setShowEditPopup(true)
          setValues({
            scanName: rowData?.maScanName,
            dealDate: moment(rowData?.dealDate)?.format('YYYY-MM-DD'),
            startDate: moment(rowData?.scanStartDate)?.format('YYYY-MM-DD'),
            endDate: moment(rowData?.scanEndDate)?.format('YYYY-MM-DD'),
            id: rowData?.maScanId
          })
          setShowCreateNewPopup(true)
        }
      }
    ] : []
    const onHideContextualMenu = () => setShowContextualMenu(false);
    const linkRef = useRef(null);
    return (
      <>
        <ContextMenu
          items={menuItems}
          hidden={showContextualMenu}
          target={linkRef}
          onItemClick={onHideContextualMenu}
          onDismiss={onHideContextualMenu}
          className='grid-context-menu'
         data-attribute="MergerAcquisitionScan_container_Default_ContextMenu">
          <a className="context-menu" ref={linkRef} href="/mergerandacquisitionscan" onClick={onShowContextualMenu}><span className='fa fa-ellipsis-h'> </span> </a>
        </ContextMenu>
      </>
    )
  }

  const isValidToSubmit = (allValues: any) => {
    validateValues('all', allValues)
    let isValid = true
    if (!allValues?.startDate
      || !allValues?.endDate
      || !allValues?.scanName
      || !allValues?.dealDate
      || allValues?.scanNameError
      || allValues?.startDateError
      || allValues?.endDateError
      || allValues?.dealDateError
    ) {
      isValid = false
    }
    return isValid
  }


  const handleClickAdd = () => {
    let isValid = isValidToSubmit(values)
    dispatch(isScanSaved({ status: '', message: '' }))
    let payload: any = {
      maScanName: values?.scanName,
      dealDate: values?.dealDate,
      scanStartDate: values?.startDate,
      scanEndDate: values?.endDate,
      savedBy: userData?.emailId
    }
    if (isValid && !showEditScanPopup) {
      dispatch(saveScan(payload))
    } else if (isValid && showEditScanPopup) {
      payload.maScanId = values?.id
      dispatch(updateScan(payload))
    }
  }

  const validateName = (value: any) => {
    if (!value) {
      setValues((prev: any) => ({ ...prev, scanNameError: 'Please provide M&A Scan name' }))
    } else if (value?.length > 100) {
      setValues((prev: any) => ({ ...prev, scanNameError: 'Please provide M&A Scan name less than 100 characters' }))
    } else {
      setValues((prev: any) => ({ ...prev, scanNameError: '' }))
    }
  }

  const validateEndDate = (value: any) => {
    if (!value) {
      setValues((prev: any) => ({ ...prev, endDateError: 'Please provide Scan End Date' }))
    } else if (values?.startDate && moment(values?.startDate).isAfter(value)) {
      setValues((prev: any) => ({ ...prev, endDateError: 'Please provide Scan End Date greater than Scan Start Date', endDate: null }))
    } else {
      setValues((prev: any) => ({ ...prev, endDateError: '' }))
    }
  }
  const validateStartDate = (value: any) => {
    if (!value) {
      setValues((prev: any) => ({ ...prev, startDateError: 'Please provide Scan Start Date' }))
    } else if (values?.endDate && moment(value).isAfter(values?.endDate)) {
      setValues((prev: any) => ({ ...prev, startDateError: 'Please provide Scan Start Date less than Scan End Date', startDate: null }))
    } else {
      setValues((prev: any) => ({ ...prev, startDateError: '' }))
    }
  }

  const validateDealDate = (value: any) => {
    if (!value) {
      setValues((prev: any) => ({ ...prev, dealDateError: 'Please provide Deal Date' }))
    } else {
      setValues((prev: any) => ({ ...prev, dealDateError: '' }))
    }
  }

  const validateUploadAssets = () => {
    if(list?.length === 0){
      setValues((prev: any) => ({ ...prev, uploadAssetsError: 'Please upload attachment' }))
    } else {
      setValues((prev: any) => ({ ...prev, uploadAssetsError: '' }))
    }
  }


  const validateValues = (name: string, value: any) => {
    switch (name) {
      case 'scanName':
        validateName(value)
        break;
      case 'endDate':
        validateEndDate(value)
        break;
      case 'startDate':
        validateStartDate(value)
        break;
      case 'dealDate':
        validateDealDate(value)
        break;
      default:
        validateName(value?.scanName)
        validateEndDate(value?.endDate)
        validateStartDate(value?.startDate)
        validateDealDate(value?.dealDate)
        break;
    }
  }

  const handleNameChange = (e: any, value: any) => {
    setValues((prev: any) => ({ ...prev, [e?.target?.name]: value }))
    validateValues(e?.target?.name, value)
  }

  const handleDatesChange = (value: any, name: string) => {
    if (name === 'endDate') {
      setValues((prev: any) => ({ ...prev, endDate: moment(value)?.format('YYYY-MM-DD'), endDateError: '' }))
    } else if (name === 'startDate' && values?.endDate && new Date(value) > new Date(values?.endDate)) {
      setValues((prev: any) => ({ ...prev, startDate: moment(value)?.format('YYYY-MM-DD'), startDateError: '' }))
    } else {
      setValues((prev: any) => ({ ...prev, [name]: moment(value)?.format('YYYY-MM-DD'), dealDateError: '' }))
    }
    validateValues(name, value)
  }

  const setGridFilters = (value: any) => {
    if (JSON.stringify(value) !== '{}') {
      dispatch(setFilters(value))
    }
  }

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      dispatch(setPaginationData(fetchData.data))
    }
  }, [])

  const handleDateFilter = (date: Date, search: any, UpdatedDate: any, name: string) => {
    dispatch(setFilters({ [name]: moment(date).format('YYYY-MM-DD') }))
    UpdatedDate.current = date;
  }

  const handleClearDateFilter = (search: any, UpdatedDate: any, name: string) => {
    dispatch(setFilters({ [name]: "" }))
    UpdatedDate.current = undefined;
  }

  const exportScans = () => {
    let payload = {
      loggedInMail: userData?.emailId,
      globalSearch: globalDebounce,
      columnFilters: Object
        .keys(filters)
        ?.map((filter: any) => ({
          'field': filter,
          'value': filters[filter]
        })),
      onlyActive: true
    }
    dispatch(getScansExcelExportFile(payload))
  }

  const onSearchGlobal = (e: any, isKeyPressed?: any) => {
    setGlobalSearchBox(isKeyPressed ? e : e?.target?.value)
  }

  const clearGlobalSearch = () => {
    setGlobalSearchBox('')
  }

  const uploadAssetBtnClick = () => {
    setShowUploadAssetsPopUp(true)
    setShowCreateNewPopup(false)
  }

  const closeUploadAssetsModal = () => {
    setShowUploadAssetsPopUp(false)
    setList([])
  }

  const isValidFormat = (file: File) => {
    const extension = file.name.split(".").at(-1) || "";

    return ".xlsx,.xls".split(",").includes(`.${extension.toLowerCase()}`);
  };

  const handleFileChange = (event: any) => {
    const files = event.target.files;
    if (!files?.length) {
      return;
    }
    let validFiles: any = [...files].filter((file: File) => isValidFormat(file));
    if (validFiles.length) {
      setList([validFiles[0]]);
      setValues((prev: any) => ({ ...prev, uploadAssetsError: '' }))
    } else {
      setValues((prev: any) => ({ ...prev, uploadAssetsError: 'Please upload only accepted file formats i.e .xlsx, .xls' }))
    }
    // reset file input
    event.target.value = null;
  };

  const removeUploadedFile = () => {
    setList([])
    setValues((prev: any) => ({ ...prev, uploadAssetsError: 'Please upload attachment' }))
  }

  const isValidToSubmitUpload = () => {
    validateUploadAssets()
    if(!list?.length){
      return false
    }
    return true
  }

  const onUploadAssetsClick = () => {
    let isValid = isValidToSubmitUpload()
    if(isValid){
      const formData = new FormData();
      for (const element of list) {
        formData.append("Files", element);
      }
      formData.append("MAScanId", values.id)
      formData.append("SavedBy", userData?.emailId)
  
      dispatch(uploadAssets(formData))
    }
  }



  if (!isAuthorized(permissions?.ViewMAScanning)) {
    return <div className="access-denied">
      <h1>ACCESS DENIED</h1>
      <h6>{ASSET_INVENTORY.ACCESS_DENIED_M_AND_A_SCAN}</h6>
    </div>
  }

  return (
    <MergerAcquisitionHome
      mergerandacquisitionscanColumnData={gridData}
      totalRecords={totalRecords}
      pagesCount={pagesCount}
      setGridFilters={setGridFilters}
      handleDateFilter={handleDateFilter}
      handleClearDateFilter={handleClearDateFilter}
      CreateNewScanClick={CreateNewScanClick}
      CustomCell={CustomCell}
      showCreateNewScanPopup={showCreateNewScanPopup}
      hidePopup={hidePopup}
      showEditScanPopup={showEditScanPopup}
      handleClickAdd={handleClickAdd}
      handleNameChange={handleNameChange}
      handleDatesChange={handleDatesChange}
      values={values}
      isScanSavedFlag={isScanSavedFlag}
      fetchAction={fetchAction}
      filters={filters}
      paginationData={paginationData}
      dealDate={dealDate}
      scanStartDate={scanStartDate}
      scanEndDate={scanEndDate}
      createdDate={createdDate}
      exportScans={exportScans}
      onSearchGlobal={onSearchGlobal}
      globalSearchBox={globalSearchBox}
      clearGlobalSearch={clearGlobalSearch}
      uploadAssetBtnClick={uploadAssetBtnClick}
      closeUploadAssetsModal={closeUploadAssetsModal}
      showUploadAssetsPopUp={showUploadAssetsPopUp}
      setShowUploadAssetsPopUp={setShowUploadAssetsPopUp}
      list={list}
      handleFileChange={handleFileChange}
      onUploadAssetsClick={onUploadAssetsClick}
      removeUploadedFile={removeUploadedFile}
      isAssetsUploaded={isAssetsUploaded}
    />
  )
}

export default MergerAcquisitionHomeContainer;